(function () {

  'use strict';

  /*NOTA: Always be explicit about the dependencies of a sub-module.
  Do not rely on dependencies inherited from a parent module.*/
  angular
    .module('risparmioBuoni', [
      'services.risparmioBuoni',
      'services.uikitProxy'
    ])
})();